import React, { FC } from 'react';
import { useT } from 'hooks';
import imageAction from './img/image.png';
import s from './index.module.scss';

export const Alert: FC = () => {
	const { T } = useT();

	function refreshPage() {
		window.location.reload();
	}

	return (
		<div className={s.alert_overlay} id='alert'>
			<div className={s.spinner_wrapper}>
				<div className={s.spinner}>
					<svg width='68' height='68'>
						<circle
							stroke='#DADADA'
							strokeWidth='3'
							cx='34'
							cy='34'
							r='32'
							fill='transparent'
							strokeLinecap='round'
							strokeDasharray='140'
							strokeDashoffset='0'
						></circle>
					</svg>
				</div>
			</div>
			<div className={s.alert_message} id='alertMessage'>
				<p className={s.alert_message_title} dangerouslySetInnerHTML={{ __html: T('error_10') }} />
				<p className={s.alert_message_description}>{T('error_11')}</p>
				<img className={s.image_action} src={imageAction} alt='imageAction' />
				<p className={s.alert_message_button} onClick={refreshPage}>
					{T('button_7')}
				</p>
			</div>
		</div>
	);
};
